import { gql } from '@apollo/client'

export const GET_VOOH_CAMPAIGN_EMISSIONS = gql`
  query voohCampaignEmissions($voohCampaignId: ID!) {
    voohCampaignEmissions(voohCampaignId: $voohCampaignId) {
      campaignEmissions
      crmEmissions
      crmEmissionAdjustmentRate
      crmAdjustedEmissions
    }
  }
`
